<div class="invite-user-card">
  <app-classroom-user-card class="user" [user]="userCard"></app-classroom-user-card>
  <div class="actions">
    <ng-container *ngIf="isInvited">
      <span class="status"> {{ 'classrooms.invite.invitation-sent' | customLocale }}</span>
    </ng-container>
    <ng-container *ngIf="isAccepted">
      <span class="status"> {{ 'invite-card.invitation-accepted' | customLocale }} </span>
    </ng-container>
    <ng-container *ngIf="!isInvited && !isAccepted">
      <span class="action" (click)="onInvite()"> {{ 'classrooms.invite.invite' | customLocale }}</span>
    </ng-container>
  </div>
</div>